/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Download({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.6 2a.6.6 0 0 0-1.2 0v7.551L5.424 7.576a.6.6 0 1 0-.848.848l2.999 3 .01.01a.598.598 0 0 0 .83 0l.01-.01 3-3a.6.6 0 0 0-.85-.848L8.6 9.55V2Z" /><path fill="currentColor" d="M12.373 8.946a.6.6 0 0 1 .807-.263 2.6 2.6 0 0 1 1.137 1.137c.159.312.223.647.254 1.018.029.358.029.798.029 1.337v.247c0 .261 0 .492-.016.684a1.627 1.627 0 0 1-.158.62 1.6 1.6 0 0 1-.7.7 1.627 1.627 0 0 1-.62.158c-.192.016-.423.016-.684.016H3.578c-.261 0-.492 0-.684-.016a1.626 1.626 0 0 1-.62-.158 1.6 1.6 0 0 1-.7-.7 1.626 1.626 0 0 1-.158-.62c-.016-.192-.016-.423-.016-.684v-.247c0-.539 0-.98.03-1.338.03-.37.094-.705.253-1.017A2.6 2.6 0 0 1 2.82 8.683a.6.6 0 1 1 .544 1.07 1.4 1.4 0 0 0-.611.611c-.06.116-.104.275-.128.571-.025.304-.025.695-.025 1.265v.2c0 .29 0 .471.012.608.01.13.027.165.032.174a.4.4 0 0 0 .174.174.494.494 0 0 0 .174.032c.137.011.318.012.608.012h8.8c.29 0 .471 0 .608-.012a.494.494 0 0 0 .174-.032.4.4 0 0 0 .174-.174.494.494 0 0 0 .032-.174c.011-.137.012-.318.012-.608v-.2c0-.57 0-.961-.025-1.265-.024-.296-.069-.455-.128-.57a1.4 1.4 0 0 0-.611-.612.6.6 0 0 1-.263-.807Z" /></svg>;
}
;